import request from "@/utils/request";
import axios from "axios";

/**
 * 获取OSS文件上传凭证
 * @param {string} fileName - 文件名（带后缀），必需
 * @param {number} fileSize - 文件大小限制（前端不传后端默认指定10M），可选
 * @param {integer} bizType - 业务类型: 1用户信息、2商品信息、3合同信息、4其他，必需
 * @param {integer} bizId - 业务ID: 填userId，必需
 * @param {boolean} isPublic - 是否公开可读, 除了商品信息其他都填false，必需
 */
export function getOssUploadCredential({
  fileName,
  fileSize,
  bizType,
  bizId,
  isPublic,
  groupId,
}) {
  return request({
    url: "/api/mts-api/oss/upload/credential",
    method: "post",
    data: { fileName, fileSize, bizType, bizId, isPublic, groupId },
  });
}

/**
 * 直连OSS上传文件
 * @param {string} uploadUrl - 上传URL，从获取上传凭证接口返回，必需
 * @param {string} key - 获取上传凭证接口返回key值，可选
 * @param {string} policy - 获取上传凭证接口返回policy值，可选
 * @param {string} OSSAccessKeyId - 获取上传凭证接口返回ossAccessKeyId值，可选
 * @param {string} signature -获取上传凭证接口返回signature值，可选
 * @param {file} file - 本地要上传的文件，可选
 */
export function uploadFileToOss({
  uploadUrl,
  key,
  policy,
  OSSAccessKeyId,
  signature,
  contentType,
  file,
}) {
  const formData = new FormData(); //文件格式
  formData.append("key", key);
  formData.append("policy", policy);
  formData.append("OSSAccessKeyId", OSSAccessKeyId);
  formData.append("signature", signature);
  formData.append("Content-Type", contentType);
  formData.append("file", file);

  return axios({
    url: uploadUrl || "https://xoupic.oss-cn-shenzhen.aliyuncs.com",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 30000,
  });
}
/**
 * 前端OSS上传文件回调
 * @param {string} key - 获取上传凭证接口返回key值，可选
 * @param {string} status - 文件上传状态-1成功、0失败，可选
 */
export function ossUploadCallback({ key, status }) {
  return request({
    url: "/api/mts-api/oss/callback",
    method: "post",
    data: { key, status },
  });
}
/**
 * 获取私有文件的临时访问URL
 * 对于非公开的文件，上传至OSS后只在本地保留文件名信息（获取上传凭证接口返回的key字段值），前端需要查询展示该图片时需要调用该接口, 获取带签名的有实效性的临时访问url
 * 只要后端返回的文件访问url不是“https://pic.xsou.com/”开头，就能判断需要获取临时访问url
 * @param {string} fileKey - 获取上传凭证接口返回key值，可选
 */
export function getOssFileUrl({ fileKey }, options = {}) {
  return request({
    url: "/api/mts-api/oss/file",
    skipAuthRedirect: Boolean(options.skipAuthRedirect),
    skipErrorMessage: Boolean(options.skipErrorMessage),
    method: "get",
    params: {
      fileKey,
      ...(options.download ? { download: true } : {}),
    },
  });
}
